require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-rajgira-puri.json") })
        }
      }, "path---recipes-rajgira-puri");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-rajgira-puri!./.cache/json/recipes-rajgira-puri.json
// module id = 739
// module chunks = 231608221292675